<template>
  <div
    class="anticon"
    :class="getAppLogoClass"
    @click="goHome"
    :style="`background-color:${getHeaderBgColor} ;`"
  >
    <!-- <img class="ml-2 logo" style="height:20px;" :src="imgName" /> -->
    <!-- <div class="truncate md:opacity-100" :class="getTitleClass" v-show="showTitle">
      <div class="fullLogo">
          <img :src="`${imgCdnUrl}/logo-text.png`" alt="" />
        </div>
    </div> -->
  </div>
</template>
<script lang="ts" setup>
  import { computed, unref } from 'vue';
  import { useGlobSetting } from '/@/hooks/setting';
  import { useGo } from '/@/hooks/web/usePage';
  import { useMenuSetting } from '/@/hooks/setting/useMenuSetting';
  import { useDesign } from '/@/hooks/web/useDesign';
  import { PageEnum } from '/@/enums/pageEnum';
  import { useUserStore } from '/@/store/modules/user';
  import { useHeaderSetting } from '/@/hooks/setting/useHeaderSetting';

  import { useAppInject } from '/@/hooks/web/useAppInject';
  const { getIsMobile } = useAppInject();




  const props = defineProps({
    /**
     * The theme of the current parent component
     */
    theme: { type: String, validator: (v: string) => ['light', 'dark'].includes(v) },
    /**
     * Whether to show title
     */
    showTitle: { type: Boolean, default: true },
    /**
     * The title is also displayed when the menu is collapsed
     */
    alwaysShowTitle: { type: Boolean },
  });

  const { prefixCls } = useDesign('app-logo');
  const { getCollapsedShowTitle } = useMenuSetting();
  const userStore = useUserStore();
  const { title, imgCdnUrl = '' } = useGlobSetting();
  const go = useGo();
  const { getHeaderBgColor } = useHeaderSetting();
  const getAppLogoClass = computed(() => [
    prefixCls,
    props.theme,
    { 'collapsed-show-title': unref(getCollapsedShowTitle) },
  ]);
  
  const getUserInfo = computed(() => {
    const {siteInfo} = userStore.getUserInfo || {};
    return {siteInfo};
  });

  const getTitleClass = computed(() => [
    `${prefixCls}__title`,
    {
      'xs:opacity-0': !props.alwaysShowTitle,
    },
  ]);

  function goHome() {
    go(userStore.getUserInfo.homePath || PageEnum.BASE_HOME);
  }
</script>
<style lang="less" scoped>
  @prefix-cls: ~'@{namespace}-app-logo';

  .@{prefix-cls} {
    display: flex;
    align-items: center;
    padding-left: 7px;
    cursor: pointer;
    transition: all 0.2s ease;

    &.light {
      border-bottom: 1px solid @border-color-base;
    }

    &.collapsed-show-title {
      padding-left: 20px;
    }

    &.light &__title {
      color: @primary-color;
    }

    &.dark &__title {
      color: @white;
    }

    &__title {
      font-size: 16px;
      font-weight: 700;
      transition: all 0.5s;
      line-height: normal;
    }
  }
  .fullLogo{
    margin-left: 18px;
    img{
      width: 100px;
      height: 32px;
    }
  }
</style>
